var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.sideNavAccess())?_c('app-sideNav'):_vm._e(),_vm._v(" "),_c('div',{class:{'wrapper':_vm.sideNavAccess(),'o-superadmin-wrapper':_vm.userRoleSlug == 'super-admin' },attrs:{"id":"page"}},[(_vm.headerNavAccess())?_c('app-header'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('vue-progress-bar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }